module.exports = __webpack_public_path__ + "static/img/service_cont_07_zh.548d0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_cont_07_zh.png
// module id = pM6m
// module chunks = 34